module.exports = __webpack_public_path__ + "img/04.9430cbb8.png";